import { MutationTree } from "vuex";

type GeneralMutationTree = MutationTree<any>;

export const mutations: GeneralMutationTree = {};
